<template>
  <form
    class="mx-auto w-full max-w-md space-y-4 py-5 lg:pb-0"
    @submit.prevent
    @keyup.enter="!formIsLoading && submitLoginForm()"
  >
    <div class="group relative z-0 w-full">
      <input
        type="email"
        name="email"
        class="input-default-2 peer"
        :class="errors.email ? 'border-error' : 'border-neutral-20'"
        :placeholder="$t('auth.email')"
        @input="updateValue('email', $event.target.value)"
        ref="login"
      />
      <Error v-if="errors.email">
        {{ $t(errors.email[0]) }}
      </Error>
    </div>

    <div class="group relative z-0 mb-6 w-full">
      <input
        type="password"
        name="password"
        id="password"
        class="input-default-2 peer"
        :class="errors.email ? 'border-error' : 'border-neutral-20'"
        :placeholder="$t('auth.password')"
        @input="updateValue('password', $event.target.value)"
      />
      <ShowPassword name="password" />
    </div>

    <p class="relative text-right lg:-top-2">
      <AuthLink routeName="PasswordEmail">
        {{ $t("auth.not_remember_password") }}
      </AuthLink>
    </p>
    <div class="pt-16 text-center lg:pt-10">
      <Button
        theme="secondary"
        class="relative mx-auto w-full md:w-64"
        size="middle"
        @click="!formIsLoading && submitLoginForm()"
      >
        <span :class="formIsLoading && 'opacity-0'">{{
          $t("auth.sign_in")
        }}</span>
        <Loading
          v-model:active="formIsLoading"
          :can-cancel="false"
          :is-full-page="false"
          color="#fff"
          :opacity="0"
          :height="25"
          :width="25"
        />
      </Button>
    </div>
    <p class="py-2 text-center text-sm text-primary-100">
      {{ $t("auth.not_have_account") }}
      <AuthLink routeName="RegisterPatient">
        {{ $t("auth.go_to_registration") }}
      </AuthLink>
    </p>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Core/ErrorMessage.vue";
import AuthLink from "@/components/Auth/Link.vue";
import ShowPassword from "@/components/Core/ShowPassword.vue";
import Button from "@/components/Core/ButtonBase.vue";
import Loading from "vue-loading-overlay";

export default {
  components: {
    Loading,
    Button,
    ShowPassword,
    AuthLink,
    Error,
  },
  emits: ["loggedIn"],
  data() {
    return {
      formIsLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      errors: "auth/getErrors",
      isOpenModal: "modals/isOpenModal",
    }),
  },
  methods: {
    updateValue(key, value) {
      this.setPatient({ [key]: value });
    },
    async submitLoginForm() {
      this.formIsLoading = true;
      await this.loginPatient()
        .then((data) => {
          this.$gtm.trackEvent({
            event: "log_in",
            user_id: data.user.id,
          });

          this.handleLoginFromModal();

          if (data.user.sms_verified === 0) {
            return this.$router.push({ name: "AuthCodePatient" });
          }
          this.$emit("loggedIn");
          this.formIsLoading = false;
        })
        .catch(() => {
          if (this.errors.block?.[0] === "error.auth.blocked") {
            this.openModal("blockPatientModal");
          }
          this.formIsLoading = false;
        });
    },
    handleLoginFromModal() {
      if (this.isOpenModal("addCurrentPatientModal")) {
        this.closeModal("addCurrentPatientModal");
        this.openModal("addPatientModal");
      }
    },
    focusInput() {
      this.$refs.login.focus();
    },
    ...mapActions({
      loginPatient: "auth/loginPatient",
    }),
    ...mapMutations({
      setPatient: "auth/setPatient",
      closeModal: "modals/closeModal",
      openModal: "modals/openModal",
    }),
  },

  mounted() {
    this.focusInput();
  },
};
</script>
